
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trademark-registration-services/[slug]",
      function () {
        return require("private-next-pages/trademark-registration-services/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trademark-registration-services/[slug]"])
      });
    }
  